import { useLingui } from '@lingui/react/macro';
import { ChampionshipEditTab } from 'modules/championship/domain/enums/championship-edit-tab';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React, { useMemo } from 'react';
import { useFeatureFlag } from 'shared/feature-flags';
import UDTabs from 'ud-ui/components/tabs';
import { getChampionshipEditTabs } from '../edit-form/constants';

const CreateFormTabs = () => {
  const { t } = useLingui();
  const isFlow1447 = useFeatureFlag('applicationsFlow1447');

  // При создании соревнования доступна только первая вкладка: остальным нужен
  // уже сохранённый черновик.
  const tabs = useMemo(
    () =>
      getChampionshipEditTabs(isFlow1447).map((tab) => {
        const translated = { ...tab, label: t(tab.label) };
        return tab.hash === ChampionshipEditTab.COMMON ? translated : { ...translated, disabled: true };
      }),
    [t, isFlow1447],
  );

  return <UDTabs tabs={tabs} defaultTab={tabs[0]} activeRoutePattern={Pages.CHAMPIONSHIPS.EDIT} />;
};

export default CreateFormTabs;
